// extracted by mini-css-extract-plugin
export default {"container":"UP-z","darkBackground":"VP-z","whiteBackground":"WP-z","headerButton":"XP-z","calloutHeading":"YP-z","calloutSubHeading":"ZP-z"};